const ANALYTICS_TIMEZONE = 'Europe/Paris';

const MONTHS_FR = [
  'janvier',
  'février',
  'mars',
  'avril',
  'mai',
  'juin',
  'juillet',
  'août',
  'septembre',
  'octobre',
  'novembre',
  'décembre',
];

/**
 * Bornes mois civil MTD alignées API analytics (Europe/Paris).
 * @param {Date} [now]
 * @param {string} [timezone]
 */
export function getCurrentMonthToDateBounds(now = new Date(), timezone = ANALYTICS_TIMEZONE) {
  const todayLocal = now.toLocaleDateString('en-CA', { timeZone: timezone });
  const [y, m] = todayLocal.split('-');
  return {
    dateDebut: `${y}-${m}-01`,
    dateFin: todayLocal,
    timezone,
  };
}

/**
 * @param {string} ymd YYYY-MM-DD
 */
export function formatFrenchDayLabel(ymd) {
  if (!ymd || !/^\d{4}-\d{2}-\d{2}$/.test(ymd)) return ymd || '';
  const [y, m, d] = ymd.split('-').map(Number);
  const dayLabel = d === 1 ? '1er' : String(d);
  return `${dayLabel} ${MONTHS_FR[m - 1]} ${y}`;
}

/**
 * @param {{ debutLocal?: string, finLocal?: string } | null | undefined} periode
 */
export function formatMonthPeriodLabel(periode) {
  if (!periode?.debutLocal || !periode?.finLocal) return '';
  return `${formatFrenchDayLabel(periode.debutLocal)} → ${formatFrenchDayLabel(periode.finLocal)}`;
}
